import React, { useEffect, useState } from 'react';
import { ActionType, CQCombobox, IOption } from '../../../../../common/cq-inputs';
import GridTemplateConfigurationController from '../../grid-template-config.controller';

interface IProps {
    onSelect: (value: string, nameSpacePrefix: string) => void;
    actionType?: string;
    isDisabled: boolean;
    value: string;
}

const gridController = new GridTemplateConfigurationController();

export const GridRightPaneComponentName = (props: IProps) => {
    const { onSelect, actionType, isDisabled, value } = props;

    const [isLoading, setLoading] = useState(false);
    const [resultedOptions, setResultedOptions] = useState<any[]>([]);
    const [componentType, setComponentType] = useState(() => actionType);
    const [searchText, setSearchText] = useState('');
    const [timer, setTimer] = useState<any>(() => '');

    useEffect(() => {
        const asyncResult = async (value: string) => {
            setLoading(true);
            if(componentType === 'VF_PAGE'){
                setResultedOptions(await gridController.getVFPageComponentList(value) as any[]);
            }else{
                setResultedOptions(await gridController.getLWCComponentList(value) as any[]);
            }
            setLoading(false);
        }

        if(timer) {
            clearTimeout(timer);
        }
        const timerId = setTimeout(async () => {
            await asyncResult(value || searchText);
        }, 300);
        setTimer(timerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentType, resultedOptions.length, searchText, value]);

    useEffect(() => {
        setComponentType(actionType);
    }, [actionType]);

    const generationOptions = (): IOption[] => {
        return resultedOptions.map(option => {
            const name = option.Name ? option.Name : option.DeveloperName;
            return {
                id: name,
                label: name,
                value: name
            }
        });
    }

    const onActionPerformed = (actionType: ActionType, result: IOption[] | string) => {
        if(actionType === 'text-changed') {
            setSearchText(result as string);
        } else {
            const option = result as IOption[];
            onSelect(
                option[0] ? option[0].value : '',
                option[0] ? option[0].NamespacePrefix :''
            )
        }
    }

    return (
        <CQCombobox 
            config= {{
                variation: 'inline-listbox',
                isDisabled: isDisabled,
                isLoading: isLoading
            }}
            onActionPerformed= {onActionPerformed}
            options= {generationOptions()}
            limit= {generationOptions().length}
            label= {{
                label: 'Component Name',
                placeholder: 'Please search and select for option'
            }}
            value= {value === '' ? undefined : value}
        />
    )
}

export default GridRightPaneComponentName;